import React, { useEffect, useState } from "react";
import { LoadPanel ,Button} from "devextreme-react";
import { useNavigate } from "react-router-dom";

import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import SaveNewHeader from "../../../components/customPageHeader/SaveNewHeader";
import CustomTextBox from "../../../components/customTextBox/CustomTextBox";
import CustomDropdown from "../../../components/customDropDown/CustomDropdown";
import { custStatusDataSource2 } from "../../customers/data";
import {
  createCustomerContact,
  getCustomerContactCode,
} from "../../../api/companyCustomerApi";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import { TextBox } from "devextreme-react";
import CustomOtpPopup from "../../../components/customPopup/CustomOtpPopup";
import { generateOtpWithAction } from "../../../api/forgotPwdApi";
import { validateEmail } from "../../../components/login-form/LoginForm";
import { getDepartments } from "../../../api/departmentApi";
import AddNewTicketHeader from "../../../components/customPageHeader/SaveNewHeader";
import AddNewSubHeader from "../../../components/customPageHeader/SaveNewHeader";

export default function AddContact() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isOtpPopupVisible, setIsOtpPopupVisible] = useState(false);
  const [chkOtpVerify, setChkOtpVerify] = useState("N");
  const statusDataSource = [
    { text: "Active", value: "Active" },
    { text: "Inactive", value: "Inactive" },
  ];
  const [departmentList, setDepartmentList] = useState([]);

  const departmentDataSource = departmentList.map((dept) => ({
    text: dept.departmentname,
    value: dept.transid,
  }));

  const [formData, setFormData] = useState({
    contactcode: "",
    contactname: "",
    contactemail: "",
    contactnumber: "",
    designation: "",
    department: "",
    status: "Active",
  });

  const toggleOtpPopup = () => {
    setIsOtpPopupVisible(!isOtpPopupVisible);
  };
  const handleEmailVerify = async () => {
    try {
      const trimmedEmail = formData.contactemail.trim();

      if (!trimmedEmail || !validateEmail(trimmedEmail)) {
        return ToastDisplayer(
          "error",
          !trimmedEmail
            ? "Email address cannot be empty."
            : "Please enter a valid email address."
        );
      }

      setLoading(true);

      const result = await generateOtpWithAction(trimmedEmail, "C");

      if (result?.data) {
        ToastDisplayer("success", result.data.message);
        setIsOtpPopupVisible(true);
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.error || "Failed to send OTP"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field) => {
    return (e) => {
      setFormData((prev) => ({
        ...prev,
        [field]: e.value,
      }));
    };
  };

  // ── FETCH all Departments ──────────────────────────────────────────────────
  const fetchDepartments = async () => {
    try {
      setLoading(true);

      const res = await getDepartments();

      if (res.success) {
        setDepartmentList(res.data.data || []);
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to fetch departments."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchContactCode = async () => {
    try {
      setLoading(true);

      const result = await getCustomerContactCode();

      // console.log("API RESULT:", result); // 👈 ADD THIS

      if (result.success) {
        const code =
          result.data?.contact_code ||
          result.data?.contactcode ||
          result.data?.code;

        if (code) {
          setFormData((prev) => ({
            ...prev,
            contactcode: code,
          }));
        } else {
          ToastDisplayer("error", "Contact code not found in response");
        }
      } else {
        ToastDisplayer("error", result.message);
      }
    } catch (error) {
      ToastDisplayer("error", "Unable to generate contact code");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContactCode();
  }, []);

  const validateForm = () => {
    const { contactname, contactemail, contactnumber, status,department } = formData;

    if (!contactname?.trim()) {
      return "Contact name is required.";
    }

    if (!contactemail?.trim()) {
      return "Email address is required.";
    }

    if (!validateEmail(contactemail.trim())) {
      return "Please enter a valid email address.";
    }

    if (!contactnumber?.trim()) {
      return "Contact number is required.";
    }

    // Phone length validation (3–15 digits)
    if (!/^[0-9]{3,15}$/.test(contactnumber)) {
      return "Contact number must be between 3 and 15 digits.";
    }

    if (!status) {
      return "Please select a status.";
    }

    if (!department) {
      return "Please select a department.";
    }

    // if (chkOtpVerify !== "Y") {
    //   return "Please verify email first.";
    // }

    return null; // no error
  };

  const handleSaveDetails = async () => {
    const validationError = validateForm();

    if (validationError) {
      return ToastDisplayer("error", validationError);
    }

    try {
      setLoading(true);

      const payload = {
        contactname: formData.contactname,
        contactemail: formData.contactemail,
        contactnumber: formData.contactnumber,
        status: formData.status,
        department: formData.department,
        // isotpverified: chkOtpVerify,
      };

      const result = await createCustomerContact(payload);

      if (result.success) {
        ToastDisplayer("success", "Contact created successfully!");
        navigate("/contact");
      } else {
        ToastDisplayer("error", result.message);
      }
    } catch (error) {
      ToastDisplayer("error", "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}

      <div className="addCustPage">
        
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-user-add-line"></i>
              </span>
              {/* <p>Add Contact</p> */}
              <BreadCrumb/>
            </div>
          </div>
          <div className="headerContainer2">
            <Button
              text="Cancel"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleCancel}
            />

            <Button
            className="saveBtn"
              text="Save Details"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleSaveDetails}
            />

            {/* <CustomPageHeader
              // titleName={"Customers"}
              handleCreateNew={handleCreateNew}
              btnText={"Add Client"}
            /> */}
          </div>
        </div>
        {/* <AddNewSubHeader
          titleName={"Add Contact"}
          handleSaveDetails={handleSaveDetails}
          handleCancel={handleCancel}
          cancelText={"Cancel"}
          saveText={"Save Details"}
          iconClass={"ri-user-add-line"}
        /> */}
        <div className="customerMain">
          <div className="mainAddCustSection">
            <CustomTextBox
              label="Contact Code"
              placeholder="Auto-generated?"
              value={formData.contactcode}
              readOnly
              type="text"
            />

            <CustomTextBox
              label="Contact Name"
              placeholder="Enter contact name"
              value={formData.contactname}
              onChange={handleInputChange("contactname")}
              type="text"
            />

            <div className="MyTextBox">
              <label className="TextBoxLabel">
                Email Address <span className="requiredClass">*</span>
              </label>

              <div className="TextBoxWrapper">
                <TextBox
                  value={formData.contactemail}
                  onValueChanged={handleInputChange("contactemail")}
                  width={"100%"}
                  stylingMode="outlined"
                  className="TextBoxMain"
                  placeholder="Enter email address"
                  mode="text"
                />
                {/* <span className="email-arrow-icon" onClick={handleEmailVerify}>
                  <i className="ri-arrow-right-line"></i>
                </span> */}
              </div>
            </div>

            <CustomTextBox
              label="Contact Number"
              placeholder="Enter contact number"
              value={formData.contactnumber}
              onChange={handleInputChange("contactnumber")}
              type="text"
            />

            <CustomDropdown
              label={"Status"}
              myDataSource={statusDataSource}
              placeholder={"Select Status"}
              value={formData.status}
              setSelectedValue={handleInputChange("status")}
            />
            <CustomDropdown
              label={"Department"}
              myDataSource={departmentDataSource}
              placeholder={"Select Department"}
              value={formData.department}
              setSelectedValue={handleInputChange("department")}
            />
          </div>
        </div>
        <CustomOtpPopup
          visible={isOtpPopupVisible}
          onClose={toggleOtpPopup}
          emailOtp={formData.contactemail}
          setLoading={setLoading}
          setChkOtpVerify={setChkOtpVerify}
        />
      </div>
    </>
  );
}
